/* eslint-disable import/prefer-default-export */

export enum Provinces {
  AB = 'AB', // Alberta
  BC = 'BC', // British Columbia
  MB = 'MB', // Manitoba
  NB = 'NB', // New Brunswick
  NF = 'NF', // Newfoundland and Labrador
  NS = 'NS', // Nova Scotia
  NT = 'NT', // Northwest Territories
  NU = 'NU', // Nunavut Territory
  ON = 'ON', // Ontario
  PE = 'PE', // Prince Edward Island
  SK = 'SK', // Saskatchewan
  YT = 'YT', // Yukon Territory
}
